<div class="filters-container" [formGroup]="filterForm">
    <div class="main-filters">
        <mat-form-field appearance="outline">
            <mat-label>Filter</mat-label>
            <input matInput formControlName="filter">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="fromDatePicker" formControlName="fromDate">
            <mat-datepicker-toggle [for]="fromDatePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #fromDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>To Date</mat-label>
            <input matInput [matDatepicker]="toDatePicker" formControlName="toDate">
            <mat-datepicker-toggle [for]="toDatePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #toDatePicker></mat-datepicker>
        </mat-form-field>

        <button (click)="resetDatePicker()" mat-raised-button>Reset Dates</button>
        <button (click)="sendDailyReport()" [disabled]="sendReportDisabled" color="primary" mat-raised-button>Send daily report</button>
    </div>

    @if (_canDownloadReport) {
        <div class="download-filters">
            <mat-form-field appearance="outline">
                <mat-label>From Date</mat-label>
                <input #reportFromDate [matDatepicker]="reportFromDatePicker" [value]="reportDateFromSubject | async"
                       matInput>
                <mat-datepicker-toggle [for]="reportFromDatePicker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #reportFromDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>To Date</mat-label>
                <input #reportToDate [matDatepicker]="reportToDatePicker" [value]="reportDateToSubject | async"
                       matInput>
                <mat-datepicker-toggle [for]="reportToDatePicker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #reportToDatePicker></mat-datepicker>
            </mat-form-field>
            <button (click)="downloadHourReport()" [disabled]="loading" color="primary" mat-raised-button>
                Download hours summary
            </button>
        </div>
    }
</div>

<div class="tab-container">
    <mat-tab-group (selectedIndexChange)="selectedTab = $event" [selectedIndex]="selectedTab">

        <mat-tab>
            <ng-template mat-tab-label>
                <span matTooltip="Lista veloce">Timereports list</span>
            </ng-template>

            <app-timereport-list-table [canChangeUser]="canChangeUser" searchMode='quick'></app-timereport-list-table>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                @if (performingSlowSearch$ | async) {
                    <div class="tab-label-loading">
                        <mat-icon matTooltip="Searching...">cloud_sync</mat-icon>
                    </div>
                } @else {
                    <div class="tab-label-loaded">
                        <mat-icon matTooltip="Lista esaustiva ({{slowListElements}} timereports)">cloud_done</mat-icon>
                        <span>({{ slowListElements }})</span>
                    </div>
                }
            </ng-template>

            <app-timereport-list-table (updateTotalElements)="slowListElements = $event" [canChangeUser]="canChangeUser"
                                       searchMode='slow'></app-timereport-list-table>
        </mat-tab>
    </mat-tab-group>
</div>
